import { matchPath } from "react-router-dom";

import { navigablePaths } from "@navigationRouting/navigationRouting";

/**
 * Resolves a concrete URL pathname to its NRO route pattern for use in
 * Datadog RUM error context. Returns the pattern string (e.g.
 * "/:app_group_id/campaigns/edit/:campaign_id") or undefined if no
 * NRO route matches.
 *
 * Uses the full (unfiltered) navigablePaths registry so that routes
 * behind disabled feature flippers are still resolved -- this is
 * intentional for observability.
 */
export function resolveNroPath(pathname: string): string | undefined {
  return navigablePaths.find((path) => matchPath(path as string, pathname)) as string | undefined;
}
